import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/framework/services/base.service';
import { APIUrl } from '../../features-common/constants/APIUrls'


@Injectable({
  providedIn: 'root'
})
export class LoginService extends BaseService {
  apiUrl = APIUrl;

  constructor() {
    super();
  }

  login(formData: any): Observable<any> {
    let url = this.apiUrl.login;
    return this.httpService.post(url, formData);
  }

  verify(rememberMe: string, otp: number, username: string, userInfo, endUrl): Observable<any> {
    let url = endUrl;
    let formdata: any = {
      rememberMe: rememberMe,
      username: username,
      otp: otp,
      userInfo: userInfo
    }
    return this.httpService.post(url, formdata)
  }
  resendCode(params) {
    let url = this.apiUrl.resendCode;
    return this.httpService.post(url, params)
  }
  forgotPassword(params) {
    let url = this.apiUrl.forgotPassword;
    return this.httpService.postParams(url, params);
  }
  resetPassword(httpParams) {
    let url = this.apiUrl.resetPassword;
    return this.httpService.postParams(url, httpParams);
  }
  logout() {
    let url = this.apiUrl.logOut;
    return this.httpService.post(url, {});
  }

  getRefreshTimeOut():Observable<any>{
    let url = this.apiUrl.refreshTimeOut
    return this.httpService.get(url)
  }
  putConnections(connectionFlag):Observable<any>{
    let url = this.apiUrl.enablePIRConnections
    let params: any = new HttpParams().set('configValue', connectionFlag)
    return this.httpService.put(url,params)
  }
  getConnectionFlag():Observable<any>{
    let url = this.apiUrl.getConnectionFlag
    return this.httpService.get(url)
  }
}
